<script>
import * as api from '../../api/api'
import * as common from '../../api/common'
// import * as utils from '@/api/utils'
import { Toast } from 'vant'
export default {
  data () {
    return {
      title: '1',
      room_id: null,
      temperature: 17,
      mode: 1, // 1制冷      8制热
      open: 2, // 1开        2关
      room: {},
      maxTemp: 30,
      minTempCold: 16,
      minTempHot: 17
    }
  },
  props: {
    roomId: {
      type: Number,
      required: true
    }
  },
  methods: {
    onClickLeft () {
      this.$router.go(-1)
    },
    init () {
      this.init_habit()
    },
    init_habit () {
      const para = {}
      api.axiosRequest(api.urlList.get_habit, para).then((res) => {
        if (res.code === common.resCode.OK) {
          if (res.habit && res.habit.aircondition) {
            this.open = res.habit.aircondition.switch_status !== undefined ? res.habit.aircondition.switch_status === 1 : false
            this.mode = res.habit.aircondition.mode !== undefined ? res.habit.aircondition.mode : 1
            this.temperature = res.habit.aircondition.temperature !== undefined ? res.habit.aircondition.temperature : 20
          }
        }
      })
    },
    change_mode () {
      this.mode = this.mode === 1 ? 8 : 1
      if (this.mode === 8 && this.temperature < this.minTempHot) {
        this.temperature = this.minTempHot
      }
    },
    save () {
      const para = {
        habit: {
          aircondition: {
            switch_status: this.open ? 1 : 0, //
            temperature: this.temperature, // 温度
            mode: this.mode // 模式
          }
        }
      }
      api.axiosRequest(api.urlList.set_habit, para).then((res) => {
        if (res.code === common.resCode.OK) {
          Toast.success('保存成功')
        } else {
          Toast.fail('保存失败')
        }
      })
    },
    change_temp (flag) {
      if (this.temperature > this.maxTemp) {
        this.temperature = this.maxTemp
      }
      if (flag) {
        if (this.temperature >= this.maxTemp) {
          Toast.fail('已经是最大温度')
          return
        }
        this.temperature = this.temperature + 1
      } else {
        const minTemp = this.mode === 1 ? this.minTempCold : this.minTempHot
        if (this.temperature <= minTemp) {
          Toast.fail('已经时最低温度')
          return
        }
        this.temperature = this.temperature - 1
      }
    },
    change_open (flag) {
      this.open = flag ? 1 : 2
    }
  },
  mounted () {
    this.init()
  }
}
</script>

<template>
  <div style="width: 100%;overflow: hidden;height: 100%;display: flex;flex-direction: column">
    <van-nav-bar
        title="琴房物联设置"
        left-text=""
        left-arrow
        @click-left="onClickLeft"
    />
    <div class="temperature">
      <div class="state">
        <div class="number">{{temperature}}</div>
        <div class="other">
          <div class="symbol">℃</div>
          <div class="mode">
            <div class="img" :style="`background-image: url(${require(mode === 1 ? '../../assets/imgs/cold_symbol.png' : '../../assets/imgs/hot_symbol.png')})`"/>
            <span>{{mode === 1 ? '制冷' : '制热'}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="tip">后续预约的琴房，在签到后，将按此设置开启</div>
    <div class="status">
      <div class="row">
        <div class="left">
          <van-switch v-model="open" active-color="#37da29"></van-switch>
        </div>
        <div class="right" @click="change_mode">
          <span style="font-size: 25px">模式</span>
        </div>
      </div>
      <div class="row">
        <div class="down" @click="change_temp(false)">-</div>
        <div class="text">温度</div>
        <div class="up" @click="change_temp(true)">+</div>
      </div>
    </div>
    <div style="width: 100%;height: 80px;display: flex;justify-content: center;align-items: center;margin-top: auto;margin-bottom: 31px">
      <van-button type="info" style="width: 92.533%;" color="#74B0F9" @click="save()">保存</van-button>
    </div>
  </div>
</template>

<style scoped lang="scss">
.title {
  width: 100%;
  padding: 5px;
  border-bottom: 1px solid #eee;
}
.tip {
  display: flex;
  width: 100%;
  background: #eeeeee;
  justify-content: center;
  align-items: center;
  color: #999999;
  font-size: 10px;
  line-height: 3;
}
.temperature {
  background: #eeeeee;
  width: 100%;
  height: 20.8365817%;
  //background: red;
  display: flex;
  align-items: center;
  justify-content: center;
  .state {
    display: flex;
    flex-direction: row;
    padding: 0;
    height: 80px;
    width: 100%;
    align-items: center;
    justify-content: center;
    .number {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 80px;
      height: 100%;
    }
    .other {
      margin-left: 10px;
      height: 100%;
      display: flex;
      flex-direction: column;
      .symbol {
        display: flex;
        align-items: center;
        font-size: 21px;
        height: 50%;
      }
      .mode {
        display: flex;
        align-items: center;
        font-size: 16px;
        height: 50%;
        .img {
          width: 16px;
          height: 16px;
          background-image: url("../../assets/imgs/cold_symbol.png");
          background-size: cover;  /* 让图片充满整个 div */
          background-position: center;  /* 保证图片居中显示 */
          background-repeat: no-repeat;  /* 防止图片重复 */
        }
      }
    }
  }
}
.status {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 33.58320%;
  .row {
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 50%;
    align-items: center;
    justify-content: center;
    border-bottom: 1px solid #e0e0e0;
    .left {
      width: 50%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      border-right: 1px solid #e0e0e0;
    }
    .right {
      width: 50%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .up {
      width: 40%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      padding-left: 10%;
      font-size: 40px;
      box-sizing: border-box;
    }
    .text {
      font-size: 25px;
      width: 20%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .down {
      width: 40%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      padding-right: 10%;
      font-size: 40px;
      box-sizing: border-box;
    }
  }
}
</style>
